import DateFnsUtils from '@date-io/date-fns';
import { Button } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import CustomFormGroup from 'components/CustomFormGroup';
import DeleteAlertDialog from 'components/DeleteAlertDialog';
import { Field, FieldArray, Form, Formik, FormikHelpers } from 'formik';
import { TextField } from 'formik-material-ui';
import { DatePicker } from 'formik-material-ui-pickers';
import { EditEstimationPointModels, useEstimationPoint } from 'hooks/estimationpoint';
import { ProjectDetailModel } from 'hooks/project';
import React, { FC, useState } from 'react';
import { toast } from 'react-toastify';
import { toFormikErrors } from 'utils/errorHandler';

interface EstimationPointFormProps {
    values: EditEstimationPointModels;
    project: ProjectDetailModel;
    onEditEstimationPoints: () => void;
}

export const EditEstimationPointForm: FC<EstimationPointFormProps> = (props: EstimationPointFormProps) => {

    const { editEstimationPoints, deleteEstimationPoints } = useEstimationPoint();
    const [alertOpen, setAlertOpen] = useState(false);

    const handleNewEstimation = async (values: EditEstimationPointModels, helpers: FormikHelpers<EditEstimationPointModels>) => {
        helpers.setSubmitting(true);

        const response = await editEstimationPoints(props.project.id, values);

        if (response.ok) {
            toast.success('Schattingspunt aangepast.');
        } else if (response.errors) {
            const formikErrors = toFormikErrors(response.errors);
            helpers.setErrors(formikErrors);
        } else {
            toast.error('Onbekende fout. Het schattingspunt kan op dit moment niet aangepast worden.');
        }
        helpers.setSubmitting(false);
        props.onEditEstimationPoints();
    };

    const handleDelete = async (values: EditEstimationPointModels) => {
        const response = await deleteEstimationPoints(props.project.id, values);

        if (response.ok && !response.errors) {
            toast.success('De schattingspunten zijn verwijderd');
        } else {
            toast.error('Er ging iets mis, de schattingspunten kunnen niet verwijderd worden');
        }
    };

    const setDeletePopup = () => {
        setAlertOpen(!alertOpen);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Formik
                initialValues={props.values}
                onSubmit={handleNewEstimation}
            >
                {({ values }) => (
                    <Form>
                        <FieldArray
                            name="hourSpecifications"
                            render={() => (
                                values.estimationPoints.map((e, index) => {
                                    const spec = props.project.hourSpecifications.find(hs => hs.id === e.hourSpecificationId);
                                    return <CustomFormGroup key={e.hourSpecificationId}>
                                        <Field
                                            component={TextField}
                                            name={spec?.discipline.name}
                                            type="text"
                                            label={spec?.discipline.name}

                                            disabled
                                        />
                                        <Field
                                            component={TextField}
                                            name={`estimationPoints[${index}].percentage`}
                                            type="number"
                                            label="Percentage"
                                            variant="outlined"
                                        />
                                    </CustomFormGroup>;
                                })
                            )}
                        />

                        <CustomFormGroup>
                            <p>Datum</p>
                            <Field
                                component={DatePicker}
                                name="dateOfEstimation"
                                inputVariant="outlined"
                            />
                        </CustomFormGroup>

                        <CustomFormGroup>
                            <div className="estimationPointActions">
                                <DeleteAlertDialog isOpen={alertOpen} handleClose={setDeletePopup} alertTitle={'Schattingspunt verwijderen'} handleDelete={() => handleDelete(values)}>
                                    Het verwijderen van een schattingspunt kan niet ongedaan gemaakt worden. Weet u zeker dat u dit schattingspunt wil verwijderen?
                                </DeleteAlertDialog>

                                <Button variant="contained" type="submit" color="primary">Opslaan</Button>
                            </div>
                            
                        </CustomFormGroup>
                    </Form>
                )}
            </Formik>
        </MuiPickersUtilsProvider>
    );
};